import { useSuccessFeeMigrationQuery } from '@/hooks/queries/use-success-fee-migration';
import {
  shouldRenderSuccessFeeMigration,
  SuccessFeeMigrationCard,
} from '@/pages/settings/components/success-fee-migration/SuccessFeeMigrationCard';
import { Spinner, Text } from '@chakra-ui/react';
import type React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The second way out: approving the Shopify subscription that carries the fee.
 *
 * The billing card of the migration is reused as it stands rather than copied,
 * so the locked page cannot drift from the billing page about what the merchant
 * is being asked to approve. Its silence before the terms are accepted is the
 * chaining itself: the step opens the moment the acceptance is recorded, and
 * until then this says what is missing.
 */
export const LockedMigrationStep: React.FC = () => {
  const { t } = useTranslation();
  const { data: status, isLoading } = useSuccessFeeMigrationQuery({ realtime: false });

  if (isLoading) {
    return <Spinner size="sm" />;
  }

  if (!shouldRenderSuccessFeeMigration(status)) {
    return <Text color="fg.muted">{t('legal.successFeeTerms.locked.migrationPending')}</Text>;
  }

  return <SuccessFeeMigrationCard status={status} />;
};
